import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Input — modern rounded, token-driven.
 * Radius: rounded-xl (~8px). Focus ring: bordeaux via global :focus-visible.
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-xl border border-line bg-transparent px-4 py-2 text-base text-ink",
        "transition-colors duration-hover ease-out",
        "placeholder:text-muted",
        "hover:border-ink",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
